import { dsv, json } from 'd3-fetch'

const defaults = {
  apiUrl: 'https://raw.githubusercontent.com/LyonDataViz/oddata-public/master/',
  rowsLimit: 100,
  delimiter: ',',
  fieldsMap: {
    x1: ['start_longitude', 'x1'],
    x2: ['end_longitude', 'x2'],
    y1: ['start_latitude', 'y1'],
    y2: ['end_latitude', 'y2'],
    date: ['date'],
    group: ['group'],
    cumul: ['cumul'],
    timeParse: ['timeParse'],
  },
}

const getDatasets = ({ apiUrl = defaults.apiUrl } = {}) =>
  fetchDatasets(apiUrl)
    .then(ds => {
      if (!Array.isArray(ds))
        throw TypeError('Datasets are not an array of string')
      if (ds.length === 0) throw RangeError('Datasets list is empty')

      ds._status = 'ok'
      return ds
    })
    .catch(error => {
      console.warn(error.message)
      return { _status: 'error', message: error.message }
    })

const fetchDatasets = url => json(`${url}/dataset.json`)

const getMetadata = (file, { apiUrl = defaults.apiUrl } = {}) =>
  json(`${apiUrl}${file}`)

const getData = (
  metadata,
  { apiUrl = defaults.apiUrl, rowsLimit = defaults.rowsLimit } = {}
) => {
  const delimiter =
    'separator' in metadata ? metadata.separator : defaults.delimiter
  return dsv(delimiter, `${apiUrl}${metadata.file}`)
    .then(data => {
      data.splice(rowsLimit)
      return data
    })
    .then(data => data.map(addStandardFields(metadata)))
}

const addStandardFields = metadata => row => {
  // We should better work on standardization in https://github.com/LyonDataViz/gridify/
  for (let [key, candidateFields] of Object.entries(defaults.fieldsMap)) {
    const field = candidateFields.find(f => f in metadata.meta)
    if (!(key in row) && field !== undefined && metadata.meta[field] in row) {
      row[key] = row[metadata.meta[field]]
    }
  }

  return row
}

export { getDatasets, getMetadata, getData }
